import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ClientCodeService } from '@modules/dashboard/client-code.service';
import { map, Observable, of } from 'rxjs';

// Routes that are user-scoped and live at the router root without a clientCode.
const GLOBAL_ROUTE_SEGMENTS = ['home', 'chat', 'telemonitorings', 'labels', 'sharedtome', 'profile'];

export const legacyDashboardRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<UrlTree> => {
  const router = inject(Router);
  const clientCodeService = inject(ClientCodeService);

  const { cc: legacyClientCode, ...restQueryParams } = route.queryParams;

  const path = state.url.split('?')[0].replace(/^\/dashboard\/?/, '');
  const tailSegments = path ? path.split('/') : ['home'];
  const [firstSegment] = tailSegments;

  if (GLOBAL_ROUTE_SEGMENTS.includes(firstSegment)) {
    const globalUrlTree = router.createUrlTree(['/', ...tailSegments], { queryParams: restQueryParams });

    if (!legacyClientCode) {
      return of(globalUrlTree);
    }

    return clientCodeService.switchTo(legacyClientCode).pipe(map(() => globalUrlTree));
  }

  return clientCodeService
    .resolveClientCode(legacyClientCode)
    .pipe(
      map((clientCode) =>
        clientCode
          ? router.createUrlTree(['/client', clientCode, ...tailSegments], { queryParams: restQueryParams })
          : router.createUrlTree(['/disabled-account']),
      ),
    );
};
